import {
  getRequiredLabel,
  useFocusedLabel,
  useInputState
} from '../jdsinputfield/logic';

import { type InputTextareaProps } from './interface';
import { useRootRef } from '../../hooks/useRootRef';
import { forwardRef } from 'react';

export const withLogic = (
  Component: React.ComponentType<InputTextareaProps>
): React.FC<InputTextareaProps> =>
  forwardRef<HTMLTextAreaElement, InputTextareaProps>(
    (props: InputTextareaProps, ref) => {
      const { rootRef, element } = useRootRef();

      const { focused, _inputFocused, ...rest } = useFocusedLabel(
        props,
        element
      );
      const { inputState, onInvalid, stateText } = useInputState(
        props.state,
        props.required,
        props.onInvalid,
        props.stateConfig
      );

      return (
        <Component
          {...{
            ...props,
            ...rest,
            rootRef,
            label: getRequiredLabel(props.label, props.required),
            _labelFocus: focused,
            _inputFocus: _inputFocused,
            state: inputState,
            stateText,
            onInvalid,
            layerRefs: { input: ref }
          }}
        />
      );
    }
  );
export { InputTextareaProps };
